module.exports = __webpack_public_path__ + "img/product-chuti-qt-07.e969f5b2.png";